import React from 'react';

import { RadioInput} from '@sogei/react-web-components-catalog'





class SceltaTipoInvio extends React.Component {

  constructor(props) {
    super(props);
  
  }

  componentDidMount() {
  }

 

  render() {

    const sTipoInvio = (props) => {
      this.values = props.values;
      //console.log("this.values: ", JSON.stringify(this.values));
      const radioTipoInvioList = [
        {
          id: "tipoInvioS",
          label: "in verifica",
          radioValue: "S"
        },
        {   
          id: "tipoInvioN",
          label: "effettivo",
          radioValue: "N"
        }
      ]

      //console.log("props: ", JSON.stringify(props));
      return (

        props.tipoPratica == 'UN' ?
          <RadioInput
            name="tipoInvio"
            value={this.values.tipoInvio}
            inline={true}
            legend="Tipologia invio"
            radioList={radioTipoInvioList}
            inputClass={[]}
            labelClass={[]}
            event={{ onChange:  props.onChange }}
          ></RadioInput>
          : null

      )

    }

    return (
      sTipoInvio(this.props)

    );
  }

}


const defaultTipoInvio = () => {
   
  return  'N'
}  

const getTipoInvio = (esitoContestuale) => {
  if (esitoContestuale) {
    return 'B'
  }
  return defaultTipoInvio();
}
//export default SceltaTipoInvio;

export {SceltaTipoInvio, defaultTipoInvio , getTipoInvio } ;